import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxSearchNavigation } from './Searchnavigation'
import { SearchNavigationProps } from './Searchnavigation'

interface SearchnavigationBlokProps {
  blok: {
    links: SearchNavigationProps['blok']['links']
  } & SbBlokData
}

const Searchnavigation: FC<SearchnavigationBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxSearchNavigation blok={blok} />
    </div>
  )
}

export default Searchnavigation
